import { createContext, useContext, useEffect } from "react";

const ThemeContext = createContext(null);

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    // Always light mode — apply light-mode class, remove any saved dark preference
    document.documentElement.classList.add("light-mode");
    localStorage.removeItem("theme");
  }, []);

  return (
    <ThemeContext.Provider value={{ isDark: false, toggleTheme: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
};
